// Add your custom JS here.



// Esperem que la font carregui i mesurem amplada
window.addEventListener('load', () => {


});


(function() {
    ! function() {
        "use strict";
        var e = '[data-cmp-is="header"]';

        function t(e) {
            e && e.element && function(e) {
                e.element.removeAttribute("data-cmp-is"),
                    function() {
                        let e = window.scrollY;
                        const t = document.querySelector(".header-container"),
                            n = (document.getElementById("upper-content"), document.querySelector(".logoGR")),
                            o = document.querySelector(".logoSticky"),
                            c = (document.getElementById("header-content"), document.getElementById("navbarNav"), window.matchMedia("(max-width: 1082px)")),
                            a = document.querySelectorAll(".nav-link"),
                            l = Array.from(document.querySelectorAll(".cmp-search__input")),
                            i = (document.querySelectorAll(".cmp-search__icon"), document.querySelectorAll(".cmp-search__clear-icon"), c.matches ? 1 : 5);

                        function r() {
                            let a = window.pageYOffset || document.documentElement.scrollTop;
                            l.includes(document.activeElement) ? e = a : (c.matches ? 0 === a ? (t.classList.remove("hide", "show-nav-mobile"), n.classList.remove("hidden"), o.classList.add("hidden")) : a > e && a - e > i ? (t.classList.add("hide"), t.classList.remove("show-nav-mobile")) : a < e && e - a > i && (t.classList.add("show-nav-mobile"), t.classList.remove("hide"), n.classList.add("hidden"), o.classList.remove("hidden")) : 0 === a ? (t.classList.remove("hide", "show-nav"), n.classList.remove("hidden"), o.classList.add("hidden")) : a > e && a - e > i ? (t.classList.add("hide"), t.classList.remove("show-nav")) : a < e && e - a > i && (t.classList.add("show-nav"), t.classList.remove("hide"), n.classList.add("hidden"), o.classList.remove("hidden")), e = a <= 0 ? 0 : a)
                        }

                        function s(e) {
                            r()
                        }(function() {
                            const e = "150px",
                                t = "width 0.22s ease, left 0.22s ease",
                                n = Array.from(document.querySelectorAll(".cmp-search__input")),
                                o = Array.from(document.querySelectorAll(".cmp-search__clear-icon"));

                            function c(e) {
                                if (!e) return document.querySelector(".cmp-search__icon") || null;
                                let t = e.parentElement && e.parentElement.querySelector(".cmp-search__icon");
                                if (t) return t;
                                const n = e.closest(".search-container") || e.closest(".input-group") || e.closest(".cmp-search");
                                return n && (t = n.querySelector(".cmp-search__icon"), t) ? t : document.querySelector(".cmp-search__icon") || null
                            }

                            function a(e) {
                                if (!e) return;
                                const t = c(e),
                                    n = e.dataset.initialWidth || "";
                                if (e.style.width = n, e.classList.remove("expanded"), t) {
                                    const e = t.dataset.initialLeft || "";
                                    t.style.left = e || ""
                                }
                            }

                            function l() {
                                n.forEach((e => a(e)))
                            }

                            function i(t) {
                                if (!t) return;
                                l();
                                const n = c(t);
                                if (!t.dataset.initialWidth) {
                                    const e = window.getComputedStyle(t);
                                    t.dataset.initialWidth = t.style.width || e.width || t.offsetWidth + "px"
                                }
                                if (n && !n.dataset.initialLeft) {
                                    const e = window.getComputedStyle(n);
                                    n.dataset.initialLeft = n.style.left || e.left || "0px"
                                }
                                t.style.width = e, t.classList.add("expanded"), n && (n.style.left = e)
                            }
                            0 !== n.length && (n.forEach((e => {
                                const n = window.getComputedStyle(e);
                                e.dataset.initialWidth = e.style.width || n.width || e.offsetWidth + "px", e.style.transition = t
                            })), Array.from(document.querySelectorAll(".cmp-search__icon")).forEach((e => {
                                const n = window.getComputedStyle(e);
                                e.dataset.initialLeft = e.style.left || n.left || "0px", e.style.transition = t
                            })), n.forEach((e => {
                                e.addEventListener("focus", (function() {
                                    i(e)
                                })), e.addEventListener("click", (function() {
                                    e.classList.contains("expanded") || i(e)
                                })), e.addEventListener("blur", (function() {
                                    e.classList.contains("expanded") && "" === e.value.trim() && a(e), /iP(ad|hone|od)/.test(navigator.userAgent) && setTimeout((() => {
                                        window.scrollTo({
                                            top: 0,
                                            left: 0,
                                            behavior: "auto"
                                        });
                                        const e = document.getElementById("navbarNav");
                                        e && (e.style.overflowY = "auto", e.style.webkitOverflowScrolling = "touch"), document.documentElement.classList.add("no-page-scroll"), document.body.classList.add("no-page-scroll")
                                    }), 100)
                                }))
                            })), o.forEach((e => {
                                e.addEventListener("pointerdown", (function(e) {
                                    e.preventDefault(), setTimeout((() => {
                                        l(), n.forEach((e => {
                                            e.value = "", e.dispatchEvent(new Event("input", {
                                                bubbles: !0
                                            })), e.blur()
                                        }))
                                    }), 0)
                                }))
                            })))
                        })(), window.addEventListener("scroll", r), c.addEventListener("change", s), s(c);
                        let d = 0,
                            u = !1;

                        function m() {
                            const e = document.body,
                                t = document.getElementById("navbarNav"),
                                n = document.getElementById("navbar-icon");
                            d = window.scrollY || document.documentElement.scrollTop, u = !!n.closest(".show-nav-mobile"), u ? (window.scrollTo({
                                top: 1,
                                behavior: "smooth"
                            }), requestAnimationFrame((() => {
                                n.classList.remove("navbar-toggler-icon"), n.innerHTML = '<svg width="40" height="40" aria-label="nav" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M11 11L29 29M29 11L11 29" stroke="#1F2230" stroke-width="2.5" stroke-linecap="round"/>\n                    </svg>', t.classList.remove("displaynone"), t.classList.add("show-nav-mobile"), document.documentElement.style.overflow = "hidden", e.classList.add("menu-open")
                            }))) : (n.classList.remove("navbar-toggler-icon"), n.innerHTML = '<svg width="40" height="40" aria-label="nav" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M11 11L29 29M29 11L11 29" stroke="#1F2230" stroke-width="2.5" stroke-linecap="round"/>\n                    </svg>', t.classList.remove("displaynone"), t.classList.add("show-nav-mobile"), document.documentElement.style.overflow = "hidden", e.classList.add("menu-open"))
                        }

                        function g() {
                            const e = document.getElementById("navbar-icon"),
                                t = document.body,
                                n = document.getElementById("navbarNav");
                            e.classList.add("navbar-toggler-icon"), e.innerHTML = "", n.classList.remove("show-nav-mobile"), n.classList.add("displaynone"), u ? (t.classList.remove("menu-open"), document.documentElement.style.overflow = "", requestAnimationFrame((() => {
                                window.scrollTo({
                                    top: d,
                                    behavior: "smooth"
                                })
                            }))) : (t.classList.remove("menu-open"), document.documentElement.style.overflow = "")
                        }
                        document.getElementById("toggleButton").addEventListener("click", (function() {
                            const e = document.getElementById("navbarNav");
                            document.getElementById("navbar-icon"), e.classList.contains("show-nav-mobile") ? g() : m()
                        })), document.querySelectorAll("#mobile-menu .nav-link").forEach((e => {
                            e.addEventListener("click", (function() {
                                const e = document.getElementById("toggleButton");
                                e && !document.getElementById("navbar-icon").classList.contains("navbar-toggler-icon") && e.click()
                            }))
                        })), a.forEach((e => {
                            if (e.getAttribute("href")) {
                                let t = e.getAttribute("href"); - 1 !== t.indexOf(".html") && (t = t.substring(0, t.indexOf(".html")));
                                const n = window.location.pathname;
                                let o;
                                o = -1 !== n.indexOf("?") ? n.substring(0, n.indexOf("?")) : n, o.startsWith(t) ? e.classList.add("active") : e.classList.remove("active")
                            }
                        }))
                    }()
            }(e)
        }
        let n = !1,
            o = !1,
            c = null,
            a = !1;

        function l(e) {
            if (n) return void(e && e());
            n = !0;
            const t = document.createElement("script");
            t.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit", t.async = !0, t.onload = () => {
                o = !0, e && e()
            }, document.head.appendChild(t)
        }

        function i(e) {
            const t = setInterval((() => {
                const n = document.querySelector("select.goog-te-combo");
                n && (n.value = e, "function" == typeof n.onchange && n.onchange(), clearInterval(t))
            }), 200)
        }

        function r(e) {
            const t = document.querySelector(".goog-te-gadget-simple"),
                n = document.querySelector(e);
            t && n && t.parentNode !== n && n.appendChild(t)
        }

        function s(e) {
            const t = document.querySelector(e);
            t && (t.classList.contains("d-none") ? (t.classList.remove("d-none"), a ? r(e) : l((() => {
                const t = setInterval((() => {
                    document.querySelector(".goog-te-gadget-simple") && (r(e), a = !0, clearInterval(t))
                }), 100)
            }))) : t.classList.add("d-none"))
        }
        window.googleTranslateElementInit = function() {
            const e = document.querySelector("#desktop .google_translate_element");
            e && (new google.translate.TranslateElement({
                pageLanguage: "ca",
                includedLanguages: "ca,en,es,fr",
                layout: google.translate.TranslateElement.InlineLayout.SIMPLE
            }, e), a = !0, c && (i(c), c = null))
        };
        const d = document.getElementById("desktopLanguage"),
            u = document.getElementById("mobileLanguage");

        function m(t) {
            let n = document.querySelectorAll(e);
            for (let e = 0; e < n.length; e++) new t({
                element: n[e]
            });
            let o = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
                c = document.querySelector("body");
            new o((function(n) {
                n.forEach((function(n) {
                    let o = [].slice.call(n.addedNodes);
                    o.length > 0 && o.forEach((function(n) {
                        if (n.querySelectorAll) {
                            [].slice.call(n.querySelectorAll(e)).forEach((function(e) {
                                new t({
                                    element: e
                                })
                            }))
                        }
                    }))
                }))
            })).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            })
        }
        d && (d.addEventListener("click", (() => s("#desktop .google_translate_element"))), d.addEventListener("keydown", (e => {
            "Enter" !== e.key && " " !== e.key || (e.preventDefault(), s("#desktop .google_translate_element"))
        })), d.addEventListener("change", (function() {
            const e = this.value.split("|")[1];
            o ? i(e) : (c = e, l())
        }))), u && (u.addEventListener("click", (() => s(".google_translate_element_mobile"))), u.addEventListener("keydown", (e => {
            "Enter" !== e.key && " " !== e.key || (e.preventDefault(), s(".google_translate_element_mobile"))
        })), u.addEventListener("change", (function() {
            const e = this.value.split("|")[1];
            o ? i(e) : (c = e, l())
        }))), window.addEventListener("beforeunload", (function() {
            window.scrollTo(0, 0)
        })), window.addEventListener("load", (function() {
            setTimeout((() => window.scrollTo(0, 0)), 0)
        })), "loading" !== document.readyState ? m(t) : document.addEventListener("DOMContentLoaded", (function() {
            m(t)
        })), window.Granite = window.Granite || {}, Granite.I18n = Granite.I18n || {
            get: function(e) {
                return e
            }
        }
    }()
})();